import { EntidadeBase } from 'hay-core-react';
class HomologacaoIntegracaoModel extends EntidadeBase {
    constructor() { super('homologacaointegracao'); }
}

const instance = new HomologacaoIntegracaoModel();
export default instance;
